<template>
  <div v-if="showBanner" class="mb-3">
    <CAlert show color="warning" class="d-flex align-items-center mb-0">
      <fa-icon icon="exclamation-triangle" class="mr-2" size="lg" />
      <span class="flex-grow-1">
        <strong>Alerta de Licenciamento:</strong>
        A sincronização com o servidor de licenças não está sendo realizada com sucesso.
        <span v-if="hoursRemaining !== null">
          As licenças expiram em
          <strong>{{ tempoRestante }}</strong>.
        </span>
      </span>
      <CButton color="dark" size="sm" @click="abrirHistorico" class="ml-3 text-nowrap">
        <fa-icon icon="history" class="mr-1" /> Ver Histórico
      </CButton>
    </CAlert>

    <modal
      name="historico-sync"
      height="auto"
      width="700"
      :adaptive="true"
      :scrollable="true"
      :clickToClose="false"
    >
      <CloseModal :close="fecharModal" />
      <div class="modalbox">
        <div class="modalbox-header">
          <h5>Histórico de Sincronização de Licenças</h5>
        </div>
        <div class="modalbox-content">
          <CAlert v-if="lastSuccessfulSync" show color="success" class="py-2 px-3" style="font-size: 13px">
            <fa-icon icon="check-circle" class="mr-1" />
            Última sincronização bem-sucedida:
            <strong>{{ lastSuccessfulSync | datetime }}</strong>
          </CAlert>
          <CAlert v-else show color="warning" class="py-2 px-3" style="font-size: 13px">
            <fa-icon icon="times-circle" class="mr-1" />
            Nenhuma sincronização bem-sucedida registrada.
          </CAlert>

          <div v-if="loadingLogs" class="text-center p-3">
            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            Carregando...
          </div>

          <table v-else-if="logs.length" class="table table-sm table-hover table-bordered">
            <thead class="thead-light">
              <tr>
                <th>Data/Hora</th>
                <th>Status</th>
                <th>Mensagem</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in logs" :key="log.id">
                <td class="text-nowrap">{{ log.datahora_sincronizacao | datetime }}</td>
                <td class="text-center">
                  <CBadge :color="badgeColor(log.status_code)">
                    {{ log.status_code || 'N/A' }}
                  </CBadge>
                </td>
                <td style="word-break: break-word">{{ log.error || log.message || '-' }}</td>
              </tr>
            </tbody>
          </table>

          <p v-else class="text-center text-muted p-3 mb-0">
            Nenhum log de erro encontrado.
          </p>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { get } from "../../helpers/apiRequest";
import CloseModal from "../CloseModal";

export default {
  name: "AvisoLicencaSync",
  components: { CloseModal },
  data() {
    return {
      showBanner: false,
      hoursRemaining: null,
      minutesRemaining: null,
      lastSuccessfulSync: null,
      logs: [],
      loadingLogs: false,
      pollInterval: null,
    };
  },
  computed: {
    tempoRestante() {
      if (this.hoursRemaining === null) return "";
      const h = this.hoursRemaining;
      const m = this.minutesRemaining;
      if (h > 0) return `${h}h ${m}min`;
      return `${m}min`;
    },
  },
  methods: {
    badgeColor(statusCode) {
      if (statusCode >= 500) return "danger";
      if (statusCode >= 400) return "warning";
      if (!statusCode || statusCode === 0) return "dark";
      return "info";
    },
    checkStatus() {
      get("/admin/license-sync/status")
        .then((json) => {
          const data = json.data || json;
          this.showBanner = data.validity === "grace";
          this.hoursRemaining = data.hours_remaining;
          this.minutesRemaining = data.minutes_remaining;
          if (data.last_successful_sync) {
            this.lastSuccessfulSync = data.last_successful_sync;
          }
        })
        .catch(() => {});
    },
    abrirHistorico() {
      this.loadingLogs = true;
      this.logs = [];
      this.$modal.show("historico-sync");

      get("/admin/license-sync/logs")
        .then((json) => {
          const data = json.data || json;
          this.logs = data.logs || [];
          if (data.last_successful_sync) {
            this.lastSuccessfulSync = data.last_successful_sync;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loadingLogs = false;
        });
    },
    fecharModal() {
      this.$modal.hide("historico-sync");
    },
  },
  mounted() {
    this.checkStatus();
    this.pollInterval = setInterval(this.checkStatus, 5 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }
  },
};
</script>

<style scoped>
.modalbox-header {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #dee2e6;
}

.modalbox-header h5 {
  margin: 0;
  font-size: 16px;
}

.modalbox-content {
  padding: 1.25rem 1.5rem;
}
</style>